import _Vue, {PluginObject} from 'vue';

const DatePlugin: PluginObject<any> = {
  install: (vue: typeof _Vue) => {
    vue.prototype.$toDate12Hour = (date: Date) => {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0));
    };
  },
};

export default DatePlugin;
